import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import '../styles/insights.css';

/** 인사이트 아티클 목록 — 신규 글 추가 시 prerender.mjs 와 sitemap.xml 도 함께 갱신할 것 */
const ARTICLES = [
  {
    path: '/insights/planning',
    eyebrow: '기획',
    title: '아이디어를 요구사항으로 — 개발 전 준비 가이드',
    desc: '머릿속 아이디어를 개발팀이 이해할 수 있는 요구사항으로 정리하는 방법. 화면 정의부터 MVP 범위 잡기까지.',
  },
  {
    path: '/insights/cost',
    eyebrow: '비용',
    title: '웹·앱 개발 비용과 기간은 어떻게 정해지나',
    desc: '견적이 어떤 요소로 산정되는지, 규모별 대략적인 범위와 예산을 좌우하는 변수를 정리했습니다.',
  },
  {
    path: '/insights/app-development',
    eyebrow: '기술 선택',
    title: '앱 개발 방식 비교 — 네이티브·크로스플랫폼·웹앱',
    desc: '세 가지 방식의 장단점과, 어떤 상황에 무엇이 맞는지 판단하는 기준을 짚었습니다.',
  },
  {
    path: '/insights/outsourcing',
    eyebrow: '계약',
    title: '개발 외주 계약 전 확인할 것들',
    desc: '소스코드 소유권, 산출물 범위, 검수 기준, 하자보수까지. 나중에 문제가 되기 쉬운 항목을 모았습니다.',
  },
  {
    path: '/insights/maintenance',
    eyebrow: '운영',
    title: '출시가 끝이 아닙니다 — 운영과 유지보수 가이드',
    desc: '서버와 도메인 관리, 보안 업데이트, 백업, 스토어 정책 대응까지 출시 이후에 필요한 일들.',
  },
];

export default function Insights() {
  return (
    <div className="insights-page container section">
      <Seo
        title="인사이트"
        description="웹·앱 개발을 준비하는 분들을 위한 실무 가이드. 기획과 요구사항 정리, 개발 비용과 기간, 기술 선택, 외주 계약, 운영과 유지보수까지 정리했습니다."
        path="/insights"
      />

      <header className="insights-hero">
        <span className="insight-eyebrow">Insights</span>
        <h1>개발을 준비하는 분들을 위한 안내서</h1>
        <p>
          웹·앱 개발을 처음 맡기실 때 가장 어려운 건 기술이 아니라 판단입니다.
          무엇을 준비해야 하는지, 비용은 어떻게 정해지는지, 계약에서 무엇을
          확인해야 하는지 — 저희가 프로젝트를 진행하며 자주 받은 질문들을
          정리했습니다.
        </p>
      </header>

      <div className="insights-list">
        {ARTICLES.map((a) => (
          <Link to={a.path} className="insight-card" key={a.path}>
            <span className="insight-card__eyebrow">{a.eyebrow}</span>
            <h2 className="insight-card__title">{a.title}</h2>
            <p className="insight-card__desc">{a.desc}</p>
            <span className="insight-card__more">자세히 보기 →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
